import React from 'react';
import { DIALOG_TYPE } from '../../../../constants/DialogTypes';
import { Button } from '../Buttons';

interface IDialogActionButtons {
  onClose: () => void;
  handleApply: () => void;
  dialogType?: DIALOG_TYPE;
  justify?: 'start' | 'center' | 'end';
  actionButton: string;
  cancelButton?: string;
  disabled?: boolean;
}

export const DialogActionButtons = ({
  onClose,
  handleApply,
  dialogType,
  justify = 'end',
  actionButton,
  cancelButton,
  disabled,
}: IDialogActionButtons) => {
  return (
    <div
        className={`flex justify-${justify} gap-4 w-full border-t border-gray-100/80 pt-6`}
    >
      { cancelButton && (
        <Button label={cancelButton} onClick={onClose} variant='secondary' />
      ) }
      { actionButton ? (
        <Button
            label={actionButton}
            onClick={handleApply}
            dialogType={dialogType}
            variant='primary'
            disabled={disabled}
            type='submit'
        />
      ) : null }
    </div>
  );
};
